import React from 'react';
import 'src/utils/sentry';
import 'src/utils/datadog';
import 'src/services/outdated-chunk-refresher';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from 'src/components/App';
import * as ResizeObserver from 'resize-observer';
import { FullScreenLoading } from './components/FullScreenLoading';
import 'src/config/i18n';
import 'src/config/axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@bit/xenditgroup.ui-toolkit.xendit';
import 'src/assets/css/main.css';
import 'intl-pluralrules';
const element = (React.createElement(BrowserRouter, null,
    React.createElement(React.Suspense, { fallback: React.createElement(FullScreenLoading, null) },
        React.createElement(App, null))));
ResizeObserver.install();
ReactDOM.render(element, document.getElementById('root'));
